import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMcp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4 20H12.6C14.8402 20 15.9603 20 16.816 19.564C17.5686 19.1805 18.1805 18.5686 18.564 17.816C19 16.9603 19 15.8402 19 13.6V13.4C19 11.1598 19 10.0397 18.564 9.18404C18.1805 8.43139 17.5686 7.81947 16.816 7.43597C15.9603 7 14.8402 7 12.6 7H11.4C9.15979 7 8.03969 7 7.18404 7.43597C6.43139 7.81947 5.81947 8.43139 5.43597 9.18404C5 10.0397 5 11.1598 5 13.4V13.6C5 15.8402 5 16.9603 5.43597 17.816C5.81947 18.5686 6.43139 19.1805 7.18404 19.564C8.03969 20 9.15979 20 11.4 20Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 2.50024C10 2.50024 11.3328 2.50078 12 2.50024C12.6661 2.4997 14 2.50024 14 2.50024",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 11V11.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 11V11.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 15C10 15.75 10.9991 16.0005 12 16C12.9991 15.9995 14 15.75 15 15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgMcp;
